import http from "./http.js";

async function getInvoice(id) {
  try {
    const response = await http.get(`invoices/${id}`);
    const packages = response.data.packages.map(p => {
      return {
        id: p.package.id,
        title: p.package.title,
        amount: p.amount,
        type: "package",
      };
    });
    const services = response.data.services.map(s => {
      return {
        id: s.service.id,
        title: s.service.title,
        amount: s.amount,
        type: "service",
        quantity: s.quantity,
      };
    });
    const products = response.data.products.map(p => {
      return {
        id: p.product.id,
        title: p.product.title,
        article: p.article,
        amount: p.amount,
        type: "product",
      };
    });
    return {
      date: response.data.date,
      number: response.data.number,
      client: {
        id: response.data.client.id,
        title: response.data.client.title,
      },
      details: [...packages, ...services, ...products],
    };
  } catch (err) {
    throw err;
  }
}

async function updateInvoice(id, invoice) {
  try {
    const response = await http.put(`invoices/${id}`, invoice);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createInvoice(invoice) {
  try {
    const response = await http.post("invoices", invoice);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getInvoices(page = 1, rowsPerPage = 9, search = "", filter = "") {
  try {
    const response = await http.get("invoices", {
      params: {
        page,
        pageSize: rowsPerPage,
        searchTerm: search,
        invoicePaymentStatus: filter?.invoicePaymentStatus.toString() || "",
        paidFrom: filter?.dateFrom || "",
        paidTo: filter?.dateTo || "",
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function selectInvoice(page = 1, rowsPerPage = 9, search = "") {
  try {
    const response = await http.get("invoices/references", {
      params: {
        page,
        pageSize: rowsPerPage,
        searchTerm: search,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { getInvoice, updateInvoice, createInvoice, selectInvoice, getInvoices };
